const messages = {
  buttons: {
    productBrochures: "Ontdekken",
  },
  index: {
    title: "Productinformatie",
    description:
      "Wij helpen u graag met de verkoop van Bridgestone en Firestone producten.<br />Op deze pagina vindt u actuele en relevante documentatie over onze producten en technieken.",
    categories: {
      productBrochures: {
        title: "Productbrochures",
        description:
          "Hier kunt u de salestools van de nieuwste Bridgestone en Firestone producten downloaden.",
      },
      bDrive: {
        title: "Product afbeeldingen & logo's",
        description:
          "Download via B-drive alle goedgekeurde logo's en afbeeldingen van Bridgestone en Firestone producten.",
        button: "NAAR B-DRIVE",
      },
      calculator: {
        title: "Brandstofbesparing",
        description: "Gebaseerd op EU-brandstoflabel",
      },
    
      kickback: {
        description: "bonus worden toegekend aan deelnemende bedrijven op basis van de ingediende verkoopcijfers.",
      },
    },
  },
  categories: {
    info: "Productinformatie",
    priceList: "Prijslijst",
    contact: "Contact",
  },
  page: {
    description:
      "Welkom bij het informatiegedeelte over Bridgestone & Fisrestone-producten.<br />Hier vindt u actuele brochures en prijslijsten, evenals nuttige links en formulieren.",
  },
};

export default {
  messages,
};
